import { useContext, useEffect, useState } from 'react';
import { useMutation } from '@apollo/client/react';

import WorkTemplateContext, {
  WorkTemplateActionTypes,
} from '@atom/components/workTemplate/WorkTemplateContext';
import { WORK_TEMPLATE_TASK_UPDATE } from '@atom/graph/workTemplate';
import { Icon, TextField } from '@atom/mui';
import { CheckIcon, CloseIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';
import fonts from '@atom/styles/fonts';
import { WorkTemplateTaskItem } from '@atom/types/workTemplate';
import {
  doesNotHaveRolePermissions,
  ROLE_SETS,
} from '@atom/utilities/authUtilities';

import classes from './taskHeader.module.css';

const styles = {
  input: {
    fontSize: fonts.xl,
    fontWeight: '500',
  },
};

const TaskName = () => {
  const { workTemplate, task, dispatch } = useContext(WorkTemplateContext);

  const [editMode, setEditMode] = useState<boolean>(false);
  const [name, setName] = useState<string>(task.name);

  useEffect(() => {
    setName(task.name);
    setEditMode(false);
  }, [task.name, task.id]);

  const [taskTemplateUpdate] = useMutation(WORK_TEMPLATE_TASK_UPDATE);

  const setTask = (updatedTask: WorkTemplateTaskItem) => {
    dispatch({
      type: WorkTemplateActionTypes.SET_TASK,
      data: {
        ...updatedTask,
      },
    });
  };

  const handleSubmit = async () => {
    const res = await taskTemplateUpdate({
      variables: {
        input: {
          workTemplateId: workTemplate.id,
          taskId: task.id,
          name,
        },
      },
    });

    setEditMode(false);

    setTask(res?.data?.workOrderTemplateTaskUpdate);
  };

  const toggleEditMode =
    workTemplate?.published || doesNotHaveRolePermissions(ROLE_SETS.ORG_ADMIN)
      ? () => {}
      : () => setEditMode(true);

  return (
    <>
      {editMode ? (
        <div className={classes.taskNameTextfieldContainer}>
          <TextField
            autoFocus
            name="name"
            value={name}
            onChange={event => setName(event.target.value)}
            slotProps={{ input: { style: styles.input } }}
          />
          <div className={classes.buttonContainer}>
            <div className={classes.button}>
              <Icon
                color={colors.brand.blue}
                onClick={() => setEditMode(false)}
                icon={CloseIcon}
              />
            </div>
            <div className={classes.button}>
              <Icon
                color={colors.brand.blue}
                onClick={handleSubmit}
                icon={CheckIcon}
              />
            </div>
          </div>
        </div>
      ) : (
        <div className={classes.taskHeaderTitle} onClick={toggleEditMode}>
          {name}
        </div>
      )}
    </>
  );
};

export default TaskName;
